var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHomeInactive = function SvgHomeInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.905 14.14v-2.147c0-.546.469-.99 1.05-.993H9.08c.583 0 1.056.445 1.056.993h0v2.154c0 .463.394.842.886.853h1.418C13.854 15 15 13.922 15 12.593h0V6.486a1.68 1.68 0 0 0-.709-1.333L9.443 1.48a2.44 2.44 0 0 0-2.907 0L1.71 5.16c-.442.318-.704.81-.709 1.333v6.1C1 13.923 2.146 15 3.559 15h1.418c.505 0 .914-.385.914-.86h0",
    stroke: "#777",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHomeInactive;